import { Field, useFormikContext } from 'formik';
import React, { useState } from 'react';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { getCommonZoneNamesWithPagination } from '../../services/commonZoneService';
import { getZoneNamesWithPaginationExcluding } from '../../services/zoneService';
import Label from '../label/label';
import PaginatedSearchableSelectField from '../selection-field/paginated-searchable-select-field';

export const ZoneDetails = () => {
    const { translate } = useLocale();
    const { setFieldValue, values } = useFormikContext<any>();

    return (
        <>
            <div className="flex flex-row flex-1 pt-3 ">
                <div className="flex flex-col flex-1 pr-3">
                    <Label htmlFor='entryLockoutDelay'
                        className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.entryLockoutDelay)}:</Label>
                    <Field
                        name="entryLockoutDelay"
                        type="number"
                        className="flex flex-row items-center p-1 text-gray-800 text-sm bg-gray-input" />
                </div>

                <div className="flex flex-col flex-1 pr-3">
                    <Label htmlFor='exitLockoutDelay'
                        className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.exitLockoutDelay)}:</Label>
                    <Field
                        name="exitLockoutDelay"
                        type="number"
                        className="flex flex-row items-center p-1 text-gray-800 text-sm bg-gray-input" />
                </div>
            </div>
            {values.apbKey !== "0" ?
                <div className="flex flex-row flex-1 pt-3 ">
                    <div className="flex flex-col flex-1 pr-3">
                        <Label htmlFor='building'
                            className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.fullyNestedWithinZone)}:</Label>
                        <PaginatedSearchableSelectField
                            name={translate.byKey(TranslationKeys.fullyNestedWithinZone)}
                            key={"nestedZoneId"}
                            accessor='nestedZoneId'
                            dataMethod={(listQuery) => getZoneNamesWithPaginationExcluding(values.id  ?? '0', listQuery)}
                            searchAccessor={'zoneName'}
                            onSelect={(event, item) => {
                                setFieldValue('nestedZoneName', item?.label)
                                setFieldValue('nestedZoneId', item?.value)
                            }}
                            selectedItemLabel={values.nestedZoneName}
                            onDelete={(event) => {
                                setFieldValue('nestedZoneId', undefined);
                                setFieldValue('floorId', undefined);
                                setFieldValue('nestedZoneName', undefined);
                            }} />
                    </div>
                    <div className="flex flex-col flex-1 pr-3">
                        <Label htmlFor='floorId'
                            className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.commonZone)}:</Label>
                        <PaginatedSearchableSelectField
                            name={translate.byKey(TranslationKeys.commonZone)}
                            key={"commonZoneId"}
                            accessor='commonZoneId'
                            dataMethod={getCommonZoneNamesWithPagination}
                            searchAccessor={'czName'}
                            onSelect={(event, item) => {
                                setFieldValue('commonZoneName', item?.label);
                                setFieldValue('commonZoneId', item?.value);
                            }}
                            selectedItemLabel={values.commonZoneName}
                            onDelete={(event) => {
                                setFieldValue('commonZoneId', undefined);
                                setFieldValue('commonZoneName', undefined);
                            }} />
                    </div>
                </div>
                : null}
            <div className="flex flex-row flex-1 pt-3">
                <div className="flex flex-col flex-1 pr-3">
                    <Label htmlFor='maxCapacity'
                        className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.maxCapacity)}:</Label>
                    <Field
                        name="maxCapacity"
                        type="number"
                        className="flex flex-row items-center p-1 text-gray-800 text-sm bg-gray-inputflex w-full bg-gray-input" />
                </div>
                <div className="flex flex-col flex-1 pr-3">
                </div>
            </div>
        </>);
};
